import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { CognitoService } from '../../core/service/cognito.service';
import { ToastService } from 'src/app/toast/toast.service';
import { IUser } from 'src/app/core/models/user.model';


@Component({
  selector: 'app-reset-pass',
  templateUrl: './reset-pass.component.html',
  styleUrls: ['./reset-pass.component.scss'],
  standalone: false
})
export class ResetPasswordComponent {

  loading: boolean;
  user: IUser;
  isCodeSend = false;

  constructor(
    private router: Router,
    private cognitoService: CognitoService,
    private toastService: ToastService


  ) {
    this.loading = false;
    this.user = {} as IUser;
  }

  public resetPass(): void {
    this.loading = true;
    this.cognitoService.forgotPassword(this.user)
      .then((res:any) => {
        this.isCodeSend = true;
        this.loading = false;
        this.toastService.show('info', `Reset password code send to email ID ${this.user.email}`, {
          classname: 'bg-white text-dark position-fixed bottom-0 end-0 mb-7 me-3'
        });
      }).catch((err) => {
        this.toastService.showError('Error',err.message)
        this.loading = false;
      });
  }

  forgotPasswordSubmit():void {
    this.loading = true;
    this.cognitoService.forgotPasswordSubmit(this.user)
    .then((res:any) => {
      this.loading = false;
      this.toastService.show('info', 'Password updated', {
        classname: 'bg-white text-dark position-fixed bottom-0 end-0 mb-7 me-3'
      });
      this.router.navigate(['./auth/signIn']);
    }).catch((err) => {
      this.toastService.showError('Error',err.message)
      this.loading = false;
    });
  }

}
